import { Configure, Hits, useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { CustomPagination } from '../../CustomPagination';
import classNames from 'classnames';
import NrcSearchHit from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/NRCSearchHit';
import { HitProps, HIT_FIELDS, SnippetType, SnippetTypeObject } from '../../Hits/_types';

const attributesToHighlight: HIT_FIELDS[] = ['title', 'fileName', 'typeOfFile'];

const attributesToSnippet: SnippetType[] = [{ field: 'fileName', maxWords: 40 }];

const mappedSnippets = attributesToSnippet.map((x: HIT_FIELDS | SnippetTypeObject): string => {
  const obj = x as SnippetTypeObject;
  if (obj.field && obj.maxWords) {
    return `${obj.field}:${obj.maxWords}`;
  }
  if (obj.field && obj.maxWords) {
    return obj.field;
  }
  return x as HIT_FIELDS;
});

const filter =
  'NOT reportTypeFacet:"CT Instructions" AND ' +
  'NOT reportTypeFacet: "Fees CO" AND ' +
  'NOT reportTypeFacet: "Fees CT" AND ' +
  'NOT reportTypeFacet: "Cooperative Instructions" AND ' +
  'NOT reportTypeFacet: "Courier"';

export type UseStatsProps = StatsConnectorParams;

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

const ReportSearchHit = ({ hit }: HitProps) => {
  return <NrcSearchHit hit={hit} component="report" />;
};

const ReportsResultsWithSearch = (props: UseStatsProps) => {
  const { nbHits } = useStats(props);
  const showPagination = nbHits > 10;
  return (
    <div>
      <Configure
        attributesToHighlight={attributesToHighlight}
        attributesToSnippet={mappedSnippets}
        filters={filter}
        analytics={false}
        hitsPerPage={10}
      />

      <div>
        <Hits hitComponent={ReportSearchHit} />
      </div>
      <div className={classNames({ hidden: !showPagination })}>
        <CustomPagination padding={1} />
      </div>
    </div>
  );
};

const ReportsResults = (props: UseStatsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return <div>Search Results will be shown here</div>;
  }
  return <ReportsResultsWithSearch {...props} />;
};

export default ReportsResults;
